import { ADD_VENUE_AREA, DELETE_VENUE_AREA, SET_VENUE_AREA, UPDATE_VENUE_AREA } from "./venueAreas.actions";
import { v4 as uuid } from 'uuid';

export interface IOrderLocationsGroup {
    id: string;
    venue_id?: string;
    venue_group_id?:string;
    name_public: string;
    name_private: string;
    order_locations: IOrderLocation[];
    isNewField?:boolean;
    group_override?:boolean;
    enabled:boolean;
}
export interface IOrderLocation {
    id: string;
    venue_id?: string;
    venue_group_id?:string;
    group_id: string;
    name_public?: string;
    name_private?: string;
    isNewField?:boolean;
}

export const initialState: Record<string, IOrderLocationsGroup> = {}

export function VenueAreasRangesReducer(state: Record<string, IOrderLocationsGroup>, action: { type: string, payload: any; }) {
    switch (action.type) {
        case SET_VENUE_AREA:
            return {
                ...action.payload as Record<string, IOrderLocationsGroup>
            }
        case ADD_VENUE_AREA:
            const group_id = uuid();
            const createState = {...state}
            createState[group_id] = {
                id: group_id,
                ...( action.payload.venue_group_id ? {venue_group_id:action.payload.venue_group_id as string} : {venue_id: action.payload.venue_id as string }),
                name_public: action.payload.name_public as string,
                name_private: "",
                order_locations:[],
                isNewField:true,
                enabled:true
            }
            return createState
        case UPDATE_VENUE_AREA:
            const updateState  = {...state}
            updateState[action.payload.id] = action.payload;
            return updateState
        case DELETE_VENUE_AREA:
            const deleteState  = {...state}
            delete deleteState[action.payload]
            return deleteState
    }
    return state;
}
